type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
} & React.SVGProps<SVGSVGElement>;

export function HelpIcon({width, height, className, ...rest}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 20}
      height={height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...rest}
    >
      <path
        d="M10.0003 18.3346C14.6027 18.3346 18.3337 14.6037 18.3337 10.0013C18.3337 5.39893 14.6027 1.66797 10.0003 1.66797C5.39795 1.66797 1.66699 5.39893 1.66699 10.0013C1.66699 14.6037 5.39795 18.3346 10.0003 18.3346Z"
        stroke="#593B37"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5752 7.49852C7.77112 6.94158 8.15782 6.47194 8.66682 6.1728C9.17583 5.87365 9.77427 5.7643 10.3562 5.86411C10.9381 5.96393 11.4659 6.26646 11.8461 6.71813C12.2263 7.1698 12.4344 7.74146 12.4335 8.33185C12.4335 9.99852 9.93353 10.8319 9.93353 10.8319"
        stroke="#593B37"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.332V13.7487"
        stroke="#593B37"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
